'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styling = require('@rexlabs/styling');

var _coreDecorators = require('core-decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  container: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    boxSizing: 'border-box',
    height: '6rem',
    borderBottom: '1px solid transparent',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: 'grey',
    transition: 'color 150ms ease-out',
    cursor: 'pointer',

    '&:hover': {
      color: 'black'
    }
  },

  containerActive: {
    color: 'black'
  },

  containerDisabled: {
    color: 'lightgrey',
    cursor: 'default',

    '&:hover': {
      color: 'lightgrey'
    }
  }
});

var Tab = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (0, _coreDecorators.autobind)(_class = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    (0, _classCallCheck3.default)(this, Tab);
    return (0, _possibleConstructorReturn3.default)(this, (Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).apply(this, arguments));
  }

  (0, _createClass3.default)(Tab, [{
    key: 'setHandledRef',
    value: function setHandledRef(r) {
      var _props = this.props,
          setRef = _props.setRef,
          name = _props.name,
          label = _props.label;

      if (setRef) {
        setRef(r, { name: name, label: label });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          name = _props2.name,
          label = _props2.label,
          isDisabled = _props2.isDisabled;

      if (!isDisabled && onClick) {
        onClick(event, { name: name, label: label });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          s = _props3.styles,
          name = _props3.name,
          label = _props3.label,
          isActive = _props3.isActive,
          isDisabled = _props3.isDisabled;

      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({
          key: name,
          role: 'tab',
          'aria-selected': isActive.toString(),
          ref: this.setHandledRef,
          onClick: this.handleClick
        }, s('container', {
          containerActive: isActive,
          containerDisabled: isDisabled
        })),
        label
      );
    }
  }]);
  return Tab;
}(_react.Component)) || _class) || _class);
exports.default = Tab;